module.exports = __webpack_public_path__ + "src/img/ssource.e6216fa2c92ddbdf082d4275e1f6b00f.png";